import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React, { useState } from 'react';
import {
    VertModal,
    VertButton,
    Typography,
    message,
    VertIcon,
    VertLoading
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import XLSX from 'xlsx';
import generateUUID from 'Utils/generateUUID';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import { TableOutlined, UploadOutlined } from '@ant-design/icons';
import UploadSuccess from '../Modals/UploadSuccess';
import { pointsMaskToPix } from 'Utils/commons/points';
import { cepMask } from 'Utils/commons/mask';

const ExcelUploadModal = ({ isOpen, onClose, finishUpload, remainingPoints, listDocument, decimalPlaces, pointsName, balance }) => {

    const [fileLoading, setFileLoading] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [sumTotal, setSumTotal] = useState(0);
    const [listParticipant, setListParticipant] = useState([]);

    const allowedExtension = [
        'csv'
    ]

    const inputFileRef = React.useRef();

    inputFileRef?.current?.addEventListener('cancel', () => {
        setFileLoading(false);
    });

    const haveError = (resp) => {

        if (!resp.cols || resp.cols.length != 4) {
            message.error({ content: 'O número de colunas na planilha informada está inválido!', duration: 15 });
            return true;
        }

        if (!resp.rows || !resp.rows[0].length) {
            message.error({ content: 'O número de colunas na planilha informada está inválido!', duration: 15 });
            return true;
        }

        if (resp.rows.length == 1) {
            message.error({ content: 'Os dados da planilha informada estão incorretos!', duration: 15 });
            return true;
        }

        if (
            resp.rows[0][0] != 'Nome completo do participante' ||
            resp.rows[0][1] != 'CPF' ||
            resp.rows[0][2] != 'Email do participante' ||
            resp.rows[0][3] != 'Valor para este participante'
        ) {
            message.error({ content: 'As colunas estão em ordem incorreta!', duration: 15 });
            return true;
        }

        var flatRows = resp.rows.flatMap(b => b);

        if (listDocument.some(a => flatRows.some(b => b == a.cpf))) {

            var cpfs = listDocument.filter(item => flatRows.includes(item.cpf)).map(a => cepMask(a.cpf));

            if (cpfs.length > 5) {
                message.error({
                    content: `Foram informados CPF's que já estavam inseridos na solicitação: ${cpfs.join(", ")}`,
                    duration: 15
                });
            }
            else
                cpfs.forEach(cpf => {
                    message.error({ content: `O CPF: ${cpf} informado na planilha já está inserido na solicitação!`, duration: 15 });
                })
            return true;
        }

        return false;
    }

    const fileIsNotExcel = (fileExtension) => {
        return allowedExtension.includes(fileExtension);
    }

    const fileHandler = (event) => {

        if (!event.target.files.length) {
            setFileLoading(false);
            return;
        }

        let fileObj = event.target.files[0];
        var extension = fileObj.name.split('.').pop();

        if (!fileIsNotExcel(extension)) {
            setFileLoading(false);
            return message.error({ content: 'O arquivo selecionado não é um arquivo de planilha válido!', duration: 15 });
        }

        const isValidEmail = (email) => {
            const mailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim
            if (email === '' || !mailValidator.test(email)) {
                return false
            } else {
                return true
            }
        }

        const convertExcelArrayToParticipant = (listExcel) => {
            var list = [];
            var listError = [];
            listExcel.forEach(participant => {

                if (
                    !participant[0] ||
                    !participant[1] ||
                    !participant[2] ||
                    !participant[3]
                ) {
                    return;
                }

                var cpf = `${participant[1]}`.replace(/[^\w]/gi, "");
                cpf = cpf.padStart(11, '0');

                var email = participant[2];

                if (cpf.length != 11 || !cpfValidator.isValid(cpf)) {
                    if (!listError.some(a => a.type == 1 && a.cpf == cpf)) {
                        listError.push({ type: 1, cpf: cpf });
                    }
                }

                if (!isValidEmail(email)) {
                    if (!listError.some(a => a.type == 2 && a.email == email)) {
                        listError.push({ type: 2, email: email })
                    }
                }

                if (
                    listError.some(a => a.type == 1 && a.cpf == cpf) ||
                    listError.some(a => a.type == 2 && a.email == email)
                )
                    return;

                var value = parseFloat(`${participant[3]}`.replace(',', '.'));

                list.push(
                    {
                        id: generateUUID(),
                        name: `${participant[0]}`,
                        cpf: `${cpf}`,
                        email: `${email}`,
                        points: value
                    })
            });

            if (listError.length) {
                listError.forEach(error => {
                    if (error.type == 1) {
                        message.error({ content: `O CPF informado: ${error.cpf} está incorreto!`, duration: 15 });
                    }
                    if (error.type == 2) {
                        message.error({ content: `O email informado: ${error.email} está incorreto!`, duration: 15 });
                    }
                })
            }

            return list;
        }

        getExcelData(fileObj, (err, resp) => {

            if (err) {
                setFileLoading(false);
                return message.error({ content: 'Houve um erro ao converter a planilha informada!', duration: 15 });
            }

            if (haveError(resp)) {
                setFileLoading(false);
                return;
            }

            var listParticipantExcel = resp.rows.slice(1);

            var listParticipant = convertExcelArrayToParticipant(listParticipantExcel);

            var repeatedCpfs = listParticipant.map(a => a.cpf).filter((s => v => s.has(v) || !s.add(v))(new Set));            
            repeatedCpfs = [...new Set(repeatedCpfs)];

            if (repeatedCpfs.length) {
                if (repeatedCpfs.length > 5) {
                    message.error({
                        content: `Foram informados CPF's repetidos na planilha: ${cpfs.join(", ")}`,
                        duration: 15
                    });
                }
                else
                    repeatedCpfs.forEach(cpf => {
                        message.error({ content: `O CPF: ${cpf} informado na planilha está repetido!`, duration: 15 });
                    })

                setFileLoading(false);
                return;
            }

            if (listParticipant.some(a => a.points < 0 || isNaN(a.points))) {

                message.error({ content: `Foi informado algum valor incorreto!`, duration: 15 });

                setFileLoading(false);
                return;
            }

            var sumTotal = listParticipant.reduce((sum, object) => {
                return sum + parseFloat(object.points);
            }, 0);

            if (sumTotal > remainingPoints) {
                var labelSumTotal = pointsMaskToPix(sumTotal, decimalPlaces, "");
                setFileLoading(false);
                message.error({ content: 'A soma de todos os registros da planilha é maior que o saldo disponível!', duration: 15 });
                message.error({ content: `Soma da planilha: ${labelSumTotal}, saldo disponível: ${remainingPoints}`, duration: 15 });
                return;
            }

            if (listParticipantExcel.length != listParticipant.length) {
                setFileLoading(false);
                message.error({ content: 'Nem todos os registros puderam ser convertidos!', duration: 15 });
                return;
            }

            setListParticipant(listParticipant);
            setShowModalSuccess(true);
            setSumTotal(sumTotal);
            setFileLoading(false);
        });
    }

    const make_cols = (refstr) => {
        var cols = [],
            decodeRange = XLSX.utils.decode_range(refstr).e.c + 1;
        for (var i = 0; i < decodeRange; ++i) {
            cols[i] = { name: XLSX.utils.encode_col(i), key: i };
        }
        return cols;
    }

    const getExcelData = (file, callback) => {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            var rABS = !!reader.readAsBinaryString;
            reader.onload = function (e) {

                var bstr = e.target.result;
                var wb = XLSX.read(bstr, { type: rABS ? "binary" : "array", cellDates: true, raw: true });

                var wsname = wb.SheetNames[0];
                var ws = wb.Sheets[wsname];

                if (!ws || Object.keys(ws).length === 0) {
                    return callback(true, null);
                }

                var json = XLSX.utils.sheet_to_json(ws, { header: 1 });

                json = json.filter(a => a.length > 0);
                var cols = make_cols(ws["!ref"]);

                var data = { rows: json, cols: cols };

                resolve(data);
                return callback(null, data);
            };
            if (file && rABS) reader.readAsBinaryString(file);
            else reader.readAsArrayBuffer(file);
        });
    }

    return (
        <VertModal
            title={'Adicionar participante em lote'}
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                onClose();
            }}
            className="container-modal-focal-point-manage modal-terms-aprovation"
            width={640}
        >
            {
                fileLoading &&
                <>
                    <VertLoading type='spin' className='container-loading-upload-excel' />
                </>
            }
            <Row justify={'center'} className='container-modal-excel'
                gutter={[8, 8]}
            >
                <Col span={24} style={{ marginTop: '16px' }}>
                    <Row justify={'center'}>
                        <Typography.Text strong className="manage-points-details-main">
                            Passo 01:
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className="modal-excel-select-text">
                            Baixe a planilha modelo para preenchimento dos dados do participante:
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24}>
                    <Row justify={'center'} gutter={[16, 16]}>
                        <Col span={10}>
                            <VertButton
                                href={"https://premmiardev.blob.core.windows.net/files/modelo_participantes2.0.csv"}
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                            >
                                <VertIcon className={`icon-download-excel-model`} component={TableOutlined} />
                                Baixar planilha
                            </VertButton>
                        </Col>
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <div className='modal-upload-divider' />
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <Typography.Text strong className="manage-points-details-main">
                            Passo 02:
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className="modal-excel-select-text">
                            Envie a planilha preenchida com todos os dados. Veja modelo abaixo:
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24}>
                    <img
                        style={{
                            width: '100%'
                        }}
                        src='https://vertice-ds.s3.us-east-1.amazonaws.com/Assets/Images/Templates/FocalPoint/preview.jpg'
                    />
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'} gutter={[16, 16]}>
                        <Col span={10}>
                            <VertButton
                                loading={fileLoading}
                                onClick={() => {
                                    setFileLoading(true);
                                    inputFileRef.current.click();
                                }}
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                            >
                                <VertIcon className={`icon-download-excel-model`} component={UploadOutlined} />
                                Enviar planilha
                            </VertButton>
                        </Col>
                        <input
                            value=""
                            style={{
                                display: 'none'
                            }}
                            type="file"
                            ref={inputFileRef}
                            onChangeCapture={event => {
                                fileHandler(event);
                            }}
                        />
                    </Row>
                </Col>

            </Row>

            <UploadSuccess
                isOpen={showModalSuccess}
                onClose={() => { setShowModalSuccess(false) }}
                decimalPlaces={decimalPlaces}
                pointsName={pointsName}
                finishUpload={res => {
                    finishUpload({
                        save: res,
                        listParticipant: listParticipant
                    });
                    onClose();
                }}
                balance={balance}
                totalSum={sumTotal}
            />

        </VertModal >
    );
};

export default ExcelUploadModal;
